// extracted by mini-css-extract-plugin
module.exports = {"base":"Logo_base__Avq_z","white":"Logo_white__dtB1a","grey":"Logo_grey__VGQHg","primary":"Logo_primary__bj10Q","small":"Logo_small__0HwwW","big":"Logo_big__gyHdq"};